export default __webpack_public_path__ + "static/media/live-icon.afcbee87.webp";